export default __webpack_public_path__ + "static/media/ci_group_xmas_signature_logo.990e1707.png";